/* eslint-disable */

import React from 'react'
import { Form, Formik } from 'formik'
import Button from './common/Button'
import { required } from '../utils/validators'
import Input from './common/Input'
import Select from './common/Select'
import { currency, measurements } from '../utils/types'
import { useLoad } from '../hooks/request'
import { CATEGORY_LIST } from '../urls'

export default function ProductForm({ onCancel, onSubmit, loading, initialValues }) {
            const categories = useLoad({ url: CATEGORY_LIST, params: { size: 1000 } })


    const handleSubmit = (vals, actions) => {
        const data = new FormData()
        // Append image file if it exists
        if (vals.image) {
            data.append('image', vals.image, vals.image.name)
        }

        // Append other fields
        data.append('name', vals.name || '')
        data.append('measurement', vals.measurement || '')
        data.append('paymentType', vals.paymentType || '')
        data.append('barcode', vals.barcode || '')
        data.append('category', vals.category || '')
        onSubmit(data, actions)
    }

    return (
        <Formik onSubmit={handleSubmit} initialValues={{
            name: '',
            priceSale: '',
            price: '',
            priceTransfer: '',
            measurement: '',
            paymentType: '',
            count: '',
            codeContent: '',
            category: '',
            barcode: '',
            ...initialValues,

            image: null,
        }}>
                        {({ setFieldValue, values }) => (


            <Form>
                {console.log(values)}
                <div className="columns">
                    <div className="column">
                        <Input name="name" label="Наименование товара" validate={required} disabled={loading} />

                        <Select optionValue="value" optionLabel="name" name="paymentType" label="Валюта" options={currency} disabled={loading} />

                        <Select empty name="category"
                                options={categories.response ? categories.response.results : []}
                                label="Выберите категорию" loading={categories.loading} />

                        {/* <Input */}
                        {/*     step="0.01" */}
                        {/*     name="priceSale" */}
                        {/*     type="number" */}
                        {/*     label="Цена за единицу" */}
                        {/*     validate={required} */}
                        {/*     disabled={loading} */}
                        {/* /> */}
                        {/* <Input */}
                        {/*     name="price" */}
                        {/*     type="number" */}
                        {/*     step="0.01" */}
                        {/*     label="Цена поступление" */}
                        {/*     validate={required} */}
                        {/*     disabled={loading} */}
                        {/* /> */}
                        {/* <Input */}
                        {/*     step="0.01" */}
                        {/*     name="priceTransfer" */}
                        {/*     type="number" */}
                        {/*     label="Оптом цена" */}
                        {/*     validate={required} */}
                        {/*     disabled={loading} */}
                        {/* /> */}


                        <Select name="measurement" label="Измерение" optionValue="value" optionLabel="name" options={measurements} disabled={loading} />

                        <Input name="barcode" type="number" label="Штрих-код" disabled={loading} />
                    </div>
                </div>

                <div className="columns">
                        <div className="column">
                            <p className="level-left">Загрузить изображение</p>
                            <input
                                onChange={(e) => {
                                    const file = e.target.files[0]
                                    if (file) {
                                        setFieldValue('image', file)
                                    }
                                }}
                                disabled={loading}
                                name="image"
                                type="file"
                            />
                            <p>
                                {initialValues && initialValues.image
                                    ? decodeURIComponent(initialValues.image.split('/').pop())
                                    : 'Файл не загружен'}
                            </p>
                        </div>
                    </div>
                <div className="is-pulled-right">
                    <Button onClick={onCancel} icon="close-outline" text="Закрыть" className="is-danger" disabled={loading} />
                    &nbsp;&nbsp;
                    <Button loading={loading} text="Сохранить" icon="add-outline" type="submit" className="is-success" disabled={loading} />
                </div>
            </Form>
                                    )}

        </Formik>
    )
}
